export default function MrlHeader(){
    return(
        <header className="mrl-header sticky-top shadow" style={{backgroundColor:'#ffffff'}}>
            <nav className="navbar navbar-expand-lg bg-body-tertiary">
                <div className="container-fluid d-flex justify-content-center align-items-center">
                    <div className="navbar-brand">
                        <img
                            src="https://www.mattiamerlini.it/image/logo/logo.png"
                            alt="Mattia Merlini"
                            loading="lazy"
                            width="117" height="35"
                        /> 
                    </div>
                </div>
            </nav>
        </header>
    );
}